"use client";

import { c as _c } from "react/compiler-runtime";
import YouTubeEmbed from "react-lite-youtube-embed";

// lite-youtube-embed CSS is imported in app/global.css to save a request

const YouTube = t0 => {
  const $ = _c(6);
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      title: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = t1;
  } else {
    rest = $[1];
    t1 = $[2];
  }
  const title = t1 === undefined ? "YouTube video" : t1;
  let t2;
  if ($[3] !== rest || $[4] !== title) {
    t2 = <YouTubeEmbed cookie={false} containerElement="div" title={title} {...rest} />;
    $[3] = rest;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export { YouTube };